import { downgradeComponent } from "@angular/upgrade/static";
import { RouteBreadcrumbsComponent } from "@directives/_layout/_page-design/route-breadcrumbs/route-breadcrumbs.component";
import * as angular from "angular";
import { EmptyStateComponent } from "./empty-state/empty-state.component";
import { ResourceGroupDisplayComponent } from "./resourceGroupDisplay/resourceGroupDisplay.component";
import { RevealingColumnsComponent } from "./revealingColumns/revealingColumns.component";
import { TimelineComponent } from "./timeline/timeline.component";
import { TimelineEntryComponent } from "./timeline/timelineEntry.component";
import { VTabComponent } from "./v-tabs/v-tab.component";
import { VTabsComponent } from "./v-tabs/v-tabs.component";
import { VeriPanelComponent } from "./veri-panel/veri-panel.component";
import { DetailPageComponent } from "./_page-design/detail-page/detail-page.component";
import { PageActionsComponent } from "./_page-design/page-actions/page-actions.component";
import { PageTitlePillComponent } from "./_page-design/page-title-pill/page-title-pill.component";
import { PageTitleComponent } from "./_page-design/page-title/page-title.component";
import { DefaultLayoutComponent } from "./_page-design/_layouts/default-layout/default-layout.component";
import { HorizontalLayoutComponent } from "./_page-design/_layouts/horizontal-layout/horizontal-layout.component";
import { VerticalLayoutComponent } from "./_page-design/_layouts/vertical-layout/vertical-layout.component";
import { VerticalMapLayoutComponent } from "./_page-design/_layouts/vertical-map-layout/vertical-map-layout.component";

angular
    .module("app.layout.directives", [])

    .directive("revealingColumns", downgradeComponent({ component: RevealingColumnsComponent }))
    .directive("resourceGroupDisplay", downgradeComponent({ component: ResourceGroupDisplayComponent }))
    .directive("emptyState", downgradeComponent({ component: EmptyStateComponent }))

    .component("timeline", new TimelineComponent())
    .component("timelineEntry", new TimelineEntryComponent())

    .directive("veriPanel", downgradeComponent({ component: VeriPanelComponent }))

    // page layouts
    .directive("defaultLayout", downgradeComponent({ component: DefaultLayoutComponent }))
    .directive("detailPage", downgradeComponent({ component: DetailPageComponent }))
    .directive("verticalMapLayout", downgradeComponent({ component: VerticalMapLayoutComponent }))
    .directive("horizontalLayout", downgradeComponent({ component: HorizontalLayoutComponent }))
    .directive("verticalLayout", downgradeComponent({ component: VerticalLayoutComponent }))
    .directive("routeBreadcrumbs", downgradeComponent({ component: RouteBreadcrumbsComponent }))

    .directive("pageActions", downgradeComponent({ component: PageActionsComponent }))
    .directive("pageTitle", downgradeComponent({ component: PageTitleComponent }))
    .directive("pageTitlePill", downgradeComponent({ component: PageTitlePillComponent }))

    .directive("vTab", downgradeComponent({ component: VTabComponent }))
    .directive("vTabs", downgradeComponent({ component: VTabsComponent }))
    ;
